<template>
  <div class="message" :class="{ [`message--${severity}`]: severity }">
    <div class="message__content">
      <slot>
        <div>
          <div v-if="title" class="message__title">{{ title }}</div>
          <div class="message__text">{{ text }}</div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Message',

  props: {
    text: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
    },

    severity: {
      type: String,
      default: 'info',
    },
  },
}
</script>

<style lang="postcss" scoped>
.message {
  padding: var(--spacing-4);
  position: relative;
  cursor: default;

  &__content,
  &__title,
  &__text {
    font-size: 15px;
    line-height: 20px;
  }

  &__title {
    font-weight: bold;
  }

  &--success {
    background-color: var(--c-primary-color-2);
    color: var(--c-primary-neutral-3);
  }

  &--info {
    background-color: var(--c-primary-neutral-2);
    color: var(--c-primary-neutral-1);
  }

  &--warning {
    background-color: var(--c-secondary-color-4);
    color: var(--c-primary-neutral-1);
  }

  &--error {
    background-color: var(--c-secondary-color-1);
    color: var(--c-primary-neutral-3);
  }
}
</style>
